import { GHA_DISCOUNT_PREVIEW_MARKER } from 'checkout/hooks/usePendingGhaDiscountPreview'

/**
 * The GHA guest preview has no redeemable voucher until registration, so it isn't paid with a voucher.
 */
export function shouldSkipGhaDiscountPreviewVoucher(
  item: Pick<App.Checkout.ItemDiscount, 'itemInfoString'>,
  voucher: Pick<App.Checkout.AppliedVoucher, 'voucherId'>,
): boolean {
  return item.itemInfoString === GHA_DISCOUNT_PREVIEW_MARKER && !voucher.voucherId
}
